/* eslint-disable padding-line-between-statements */
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {z} from 'zod';
import {CampaignToolName} from '../copilotCampaigns.enums';

const inputSchema = z.object({});

function howToWriteBriefToDesignerAndFeedManagerTool() {
  const instructions = `
### Introduction to write the Brief to the designer.
- Provide a list of all the creatives that needed to be created and if they required to show store / products / content item
- If several of them share same design (layout and animation) and only differ by several layers content (such as different text, different image),
  instruct the designer to create a single template for all of them with dynamic parameters for the different content items, and generate the creatives from this template.
- Since a template includes dynamic parameters,for each of the templates you need to list the Dynamic parameters required in order to inject the dynamic ad elements
- Each dynamic parameter should include:
  1. name: (If possible from the account content taxonomy)
  2. type: text/image/video/link/color
  3. source: ad object name and attribute name (for example: store.address)
- also for each template you should provide brief regarding the design layout and animation if exist at all
- please provide the brief in bulleted and numbered, for example:
  - Template 1 (name:'name here')
    - Dynamic parameters:
      1. name: background image . type: image . source: static
      2. name: call to action. type: text . source : static
      3. name: product image. type: image . source :product.image1
      4. name: store address. type: text. source: store.address
    - layout and animation: 'instructions here if exist'
    - Derived Creatives:
      - Creative Card 11: background image need to include a woman. Call to action need to be : 'Shop Now'.
      - Creative Card 12: background image need to include a man. Call to action need to be : 'Buy Now'
  - Template 2 ....and so on



### Introduction to write the Brief to the feed manager
- provide a list of Feeds (Products / Stores / content) which are required for the campaign
- for each Feed please provide:
  1. name
  2. type: Products / Stores / Content
  3. Required columns:
     a. name : hopefully from the account content taxonomy
     b. type : text /image/ video / color / link
     c. used for: free text explaining if this column is needed as signal for decision tree (Decisioning),
         to show in the creative layers, or for reporting (appear in analytics reports). multiple options can apply.
         you can also hint where in the decision tree or creative it is used
  4. Source: optional. Where should the Feed Managenr get this feed (specific person, link or so). this is only valid if during the strategy session it was mentioned.

note:
  - Template dynamic parameters sources coming from feeds (products / store / content), need to match the feeds columns mapping
  - with regard to the template 'layout and animation' information:
    - if there is completely no infromation about the it, you can ask the user if there is any requirement for it or suggest it
    - you can consider the creative sentiment, which ad elements (layers) to emphasize, according to the campaign main story/message/agenda, and also the motion speed if at all.
    - if multiple content elements show in the ad linearly and none of them appear together side by side, its important to highlight which of them will be shown when animation ends,
      since this content will be more likely to be shown to the user.

`;

  async function execute({
    input: _input,
  }: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    return toolResult(JSON.stringify(instructions));
  }

  return tool({
    name: CampaignToolName.HowToWriteBriefToDesignerAndFeedManager,
    displayName: 'Reading brief instructions',
    description:
      'Get instructions on how to write a brief for the designer and a brief for Feed Managers',
    execute,
    inputSchema,
  });
}

export default howToWriteBriefToDesignerAndFeedManagerTool;
